import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import FeatureCard from "../components/FeatureCard";

import { GradientTitle } from "../components/GradientTitle";

/*
 * FeaturesSection
 * "Built Around Experiments, Not Infrastructure" — a headline, a supporting
 * paragraph, and a responsive grid of six feature cards (icon + title + blurb).
 */

const FEATURES = [
  {
    icon: SpeedIcon,
    title: "Fast & Predictable",
    subtitle: "Workload-aware scheduling with execution-time estimation.",
  },
  {
    icon: RocketLaunchIcon,
    title: "Deploy in Minutes",
    subtitle: "Launch experiments without complex infrastructure setup.",
  },
  {
    icon: DashboardCustomizeIcon,
    title: "Unified Platform",
    subtitle: "Development, execution, monitoring, and artifacts in one place.",
  },
  {
    icon: OpenInFullIcon,
    title: "Elastic Scaling",
    subtitle: "Scale from a single GPU to large distributed workloads.",
  },
  {
    icon: AltRouteIcon,
    title: "Reproducible Research",
    subtitle: "Share, fork, and reproduce experiments with ease.",
  },
  {
    icon: HealthAndSafetyIcon,
    title: "Fault Tolerance",
    subtitle: "Built-in recovery for long-running scientific workloads.",
  },
];

const FeaturesSection = () => (
  <Box
    id="features"
    sx={{
      pt: { xs: 6, md: 14 },
      pb: { xs: 6, md: 14 },
      px: { xs: 2, md: 4 },
      backgroundColor: "#fff",
    }}
  >
    <GradientTitle>Built Around Experiments, Not Infrastructure</GradientTitle>

    <Typography
      sx={{
        color: "text.secondary",
        textAlign: "center",
        maxWidth: 880,
        mx: "auto",
        mb: { xs: 5, md: 7 },
        lineHeight: 1.8,
        fontSize: { xs: "1rem", md: "1.1rem" },
      }}
    >
      EFabric makes experiments the primary unit of computation. Define your
      workflows, data, models, and compute resources. EFabric handles
      deployment, execution, scaling, and recovery.
    </Typography>

    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
        {FEATURES.map((f) => (
          <Grid item xs={12} sm={6} md={4} key={f.title}>
            <FeatureCard icon={f.icon} title={f.title} subtitle={f.subtitle} />
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default FeaturesSection;
